import { render } from "./long-insure-detail.vue?vue&type=template&id=9230012a&scoped=true&ts=true"
import script from "./long-insure-detail.vue?vue&type=script&lang=ts"
export * from "./long-insure-detail.vue?vue&type=script&lang=ts"

import "./long-insure-detail.vue?vue&type=style&index=0&id=9230012a&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9230012a"]])

export default __exports__